<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/1CCPIm4/tc-custom/9781453237236.jpg?1704761579625" alt="This image is the cover for the book Gathering, The Justice Trilogy"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Gathering, The Justice Trilogy
      </h1>
      <p class="bookDescription body article font2">
        <b>Justice and the First Unit travel to Dustland once again. Can they destroy evil and save the future world? </b><br/>Knowing they have unfinished business in the future, Justice, the Watcher, Thomas, the magician, Levi, the sufferer, and Dorian, the healer, again combine to form their unit and time-travel to Dustland. The unit hopes to guide the beings of Dustland out of the dangerous, barren place in the hopes of finding a safer home. But neither the unit nor the inhabitants of Dustland are truly safe as long as the sinister Mal remains in power. Will the unit be able to overcome Mal once and for all?  <i>The Gathering</i> is the third and final installment of Virginia Hamilton’s dystopian fantasy series, the Justice Trilogy<i>, </i>comprised of <i>Justice and Her Brothers</i>, <i>Dustland</i>, and <i>The Gathering.</i><i> </i>This ebook features an illustrated biography of Virginia Hamilton including rare photos from the author’s estate.
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Virginia  Hamilton
      </h2>
      
      <p class="authorDescription body article"><P>Virginia Hamilton (1934&ndash;2002) was the author of over forty books for children, young adults, and their older allies. Throughout a career that spanned four decades, Hamilton earned numerous accolades for her work, including nearly every major award available to writers of youth literature. In 1974, <I>M.C. Higgins, the Great</I> earned Hamilton the National Book Award, the Newbery Medal (which she was the first African-American author to receive), and the <I>Boston Globe&ndash;Horn </I><I>Book</I> Award, three of the field&rsquo;s most prestigious awards. She received the Hans Christian Andersen Award, the highest international recognition bestowed on a writer of books for young readers, in 1992, and in 1995 became the first children&rsquo;s book author to receive a MacArthur Fellowship, or &ldquo;Genius Award.&rdquo; She was also the recipient of the Coretta Scott King Award.</P><BR /></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Open Road Integrated Media
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?69fb9b1c